import clsx from 'clsx'
import React, { FC, MouseEvent } from 'react'
import useStyles from './CardContainer.styles'

type CardContainerProps = {
  isSelected?: boolean
  onClick?: (event: MouseEvent<HTMLElement>) => void
  isDesktop?: boolean
  noRadius?: boolean
  className?: string
}

const CardContainer: FC<CardContainerProps> = ({
  isSelected,
  onClick,
  isDesktop,
  children,
  noRadius = false,
  className,
}) => {
  const classes = useStyles()

  return (
    <div
      className={clsx(
        classes.root,
        {
          [classes.isSelected]: isSelected,
          [classes.isDesktop]: isDesktop,
          [classes.clickable]: onClick,
          [classes.noRadius]: noRadius,
        },
        className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

export default CardContainer
